import { useEffect, useState } from 'react';

/**
 * True only after `active` has been true for `delayMs` straight. Lets loading
 * skeletons stay invisible for fast responses (no flash) and appear on slow ones.
 */
export function useDelayedFlag(active: boolean, delayMs = 300): boolean {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!active) {
      setShown(false);
      return;
    }
    const id = setTimeout(() => setShown(true), delayMs);
    return () => clearTimeout(id);
  }, [active, delayMs]);
  return shown;
}
